import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';
import { createNetworkRequestActionSet } from '../utils';
import {
  PapiRequestSettingsUpdateUsername,
  PapiSettingsUpdateUsername,
} from '@wix/da-papi-types';

export const setUsernameRenameWidgetUsername = createAction(
  `${reduxKey}.SET_USERNAME_RENAME_WIDGET_USERNAME`,
  (username: string) => ({ username })
);

export const setUsernameRenameWidgetPassword = createAction(
  `${reduxKey}.SET_USERNAME_RENAME_WIDGET_PASSWORD`,
  (password: string) => ({ password })
);

export const {
  submit: saveUsernameRename,
  success: saveUsernameRenameSuccess,
  failure: saveUsernameRenameFailure,
} = createNetworkRequestActionSet<
  PapiRequestSettingsUpdateUsername,
  PapiSettingsUpdateUsername
>(reduxKey, 'SAVE_USERNAME_RENAME');
